import React, { useEffect, useState } from "react";
import {
  Card,
  Row,
  Col,
  FormGroup,
  CardBody,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Label,
  InputGroup,
  InputGroupText,
  Button,
} from "reactstrap";
import moment from "moment";
import { Link, useNavigate } from "react-router-dom";

import { useRequestProcessor } from "../../../requestProcessor";

import { useAtom } from "jotai";
import {
  activeChildDetail,
  appConstants,
  mobileAtom,
  requestType,
} from "../../../AtomStore/store";

import SpinnerLoading from "../../../Components/utils/SpinnerLoading";
import { handleChangeTransport } from "../../../QueryFunctions/queryfunction";
import {
  StyledCard,
  StyledCardHeader,
  StyledCardTitle,
  StyledDiv,
  StyledPara,
} from "./styles";
import FootprintDatePicker from "../../../Components/utils/FootprintDatePicker";

const Transport = () => {
  const navigate = useNavigate();

  const [request] = useAtom(requestType);
  const [activeChild] = useAtom(activeChildDetail);

  const { useMutationWrapper } = useRequestProcessor();
  const [Transport1] = [request?.service_status?.Transport1];
  const [Transport2] = [request?.service_status?.Transport2];

  const [selectedDate, setSelectedDate] = useState(moment());
  const [select, setSelect] = useState({ modal: false, type: 0 });
  const [open, setOpen] = useState(false);
  const [constants] = useAtom(appConstants);

  useEffect(() => {
    console.log(
      "[Transport] Initializing transport  for child:",
      activeChild?.id
    );
  }, [activeChild]);

  const changeTransport = useMutationWrapper(
    "changeTransport",
    (oneWay) => {
      console.log("[Transport] Calling API: /parentapp/request ", {
        selectedDate: selectedDate,
        child_id: activeChild?.id,
        request: request,
      });
      return handleChangeTransport(oneWay, selectedDate, navigate, request);
    },
    {
      onSuccess: (data) => {
        console.log("[Transport] Transport request response:", data);
      },
    }
  );

  const submit = (type) => {
    changeTransport.mutate(type);
  };
  const closeModal = () => {
    setSelect({ ...select, modal: false });
  };
  return (
    <div className="m-3">
      {changeTransport.isLoading ? <SpinnerLoading /> : <></>}
      <Card className="border-0 shadow  card-timeline ">
        <CardBody>
          <Row>
            <Col sm="12">
              <StyledDiv>
                <StyledPara>{constants?.TransportTitle}</StyledPara>
              </StyledDiv>
            </Col>
            <Col sm="6" className="mb-4 mb-xs-0">
              <Link to="#">
                <StyledCard
                  transport={Transport1}
                  onClick={() => {
                    setSelect({ modal: true, type: 1 });
                  }}
                >
                  <div className="flex justify-center items-center">
                    <i
                      className="icon-transport"
                      style={{ fontSize: "65px" }}
                    ></i>
                    <i
                      className="bi bi-arrow-up"
                      style={{ fontSize: "40px" }}
                    ></i>
                  </div>

                  <StyledCardTitle>
                    {Transport1 ? Transport1 : "Start Transport 1 Way"}
                  </StyledCardTitle>
                </StyledCard>
              </Link>
            </Col>
            <Col sm="6">
              <Link to="#">
                <StyledCard
                  transport={Transport2}
                  onClick={() => {
                    setSelect({ modal: true, type: 2 });
                  }}
                >
                  <div className="flex justify-center items-center">
                    <i
                      className="icon-transport"
                      style={{ fontSize: "65px" }}
                    ></i>
                    <i
                      className="bi bi-arrow-down-up"
                      style={{ fontSize: "40px" }}
                    ></i>
                  </div>
                  <StyledCardTitle>
                    {Transport2 ? Transport2 : "Start Transport 2 Way"}
                  </StyledCardTitle>
                </StyledCard>
              </Link>
            </Col>
          </Row>
          <FormGroup></FormGroup>
        </CardBody>
      </Card>

      <Modal isOpen={select.modal} toggle={closeModal}>
        <ModalHeader>Parent Connect</ModalHeader>
        <ModalBody>
          <FormGroup>
            <Label for="startDate">Select Transport Start/End Date</Label>
            <InputGroup className="input-group-alternative right-align">
              <InputGroupText>
                <i className="icon-calender" />
              </InputGroupText>
              <FootprintDatePicker
                setSelectedDate={setSelectedDate}
                minimumDate={moment().add("days")}
                open={open}
                defaultDate={selectedDate}
                onChange={(date) => {
                  setSelectedDate(date);
                }}
                timeFormat={false}
                inputProps={{
                  style: { fontSize: "18px", outerWidth: "100%" },
                  onOpen: () => {
                    setOpen(true);
                  },
                }}
              />
            </InputGroup>
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button
            color="success"
            onClick={() => {
              submit(select.type);
              setSelect({ ...select, modal: false });
            }}
          >
            Ok
          </Button>
          <Button
            color="secondary"
            onClick={() => setSelect({ ...select, modal: false })}
          >
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default Transport;
